module.exports = __webpack_public_path__ + "static/media/biChain.05c44763.png";